module.exports = __webpack_public_path__ + "static/media/NMDC.1481e2b3.png";